import {connect} from 'react-redux';
import AudioTracksContainer from './AudioTracksContainer';
import {AudioTrackData} from './AudioTracksTypes';
import {AudioTracksState} from './Redux/AudioTracksReducer';

interface StateProps {
    audioTracks: AudioTrackData[];
    onlyMonoAudioAvailable: boolean,
}

type State = {
    timeline: {
        audioTracks: AudioTracksState,
    },
};

export const mapState = (state: State): StateProps => {
    const {
        tracks,
        onlyMonoAudioAvailable,
    } = state.timeline.audioTracks;
    
    return {
        audioTracks: tracks,
        onlyMonoAudioAvailable,
    };
};

export default connect(mapState)(AudioTracksContainer);
